/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Target_LocationInputs */

const en_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Backup Location`)
};

const fr_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplacement cible des sauvegardes`)
};

const de_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel-Sicherungsort`)
};

const it_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizione di backup di destinazione`)
};

const ru_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевое место резервного копирования`)
};

const es_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ubicación de copia de seguridad de destino`)
};

const zh_cn2_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标备份位置`)
};

const ja_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲットバックアップ場所`)
};

const hi_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य बैकअप स्थान`)
};

const pt_pt2_options_backup_target_location = /** @type {(inputs: Options_Backup_Target_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Local de backup de destino`)
};

/**
* | output |
* | --- |
* | "Target Backup Location" |
*
* @param {Options_Backup_Target_LocationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_target_location = /** @type {((inputs?: Options_Backup_Target_LocationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Target_LocationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_target_location(inputs)
	if (locale === "de") return de_options_backup_target_location(inputs)
	if (locale === "it") return it_options_backup_target_location(inputs)
	if (locale === "ru") return ru_options_backup_target_location(inputs)
	if (locale === "es") return es_options_backup_target_location(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_target_location(inputs)
	if (locale === "ja") return ja_options_backup_target_location(inputs)
	if (locale === "hi") return hi_options_backup_target_location(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_target_location(inputs)
	return en_options_backup_target_location(inputs)
});